import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppConfig} from "../../../../conf/main";
import {AdminService} from "../../../../services/AdminService";
import {ModelProvider} from "../../../../../framework/providers/modelProvider/ModelProvider";
import {OrderService} from "../../../../services/OrderService";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {NavController} from "@ionic/angular";

@Component({
    selector: 'app-user-main-display',
    templateUrl: './user-main-display.component.html',
    styleUrls: ['./user-main-display.component.scss'],
})
export class UserMainDisplayComponent implements OnInit, OnDestroy {

    public appConfig = AppConfig;

    public interval;
    public pageData;
    public ready = false;
    public iframeSrc: SafeResourceUrl;

    constructor(public adminService: AdminService,
                public navCtrl: NavController,
                public sanitizer: DomSanitizer,
                public modelProvider: ModelProvider, public orderService: OrderService) {
    }

    ngOnInit() {
        let me = this;
        setTimeout(function () {
            me.ready = true;
            // me.refresh();
            let ex = ''
            if (me.orderService.appuser) {
                ex += '&us=' + me.orderService.appuser.data.id;
            }
            let src = me.appConfig.httpServerIp + '/templateg/?userMeet=True&mainAppuser=True' + ex;
            me.iframeSrc = me.sanitizer.bypassSecurityTrustResourceUrl(src);
        }, 1000);

        this.interval = setInterval(function () {
            let filters = {
                'userMeet': true,
                'mainAppuser': true,
                'resJson': true,
            };
            //just to check if server responding well before refreshing!
            me.modelProvider.custom('templateg', filters).then(function (data: any) {
                console.log(data);
                if (data['data']) {
                    me.ready = false;
                    setTimeout(function () {
                        me.ready = true;
                    });
                }
            });

            // me.refresh();
        }, 60 * 1000);
    }

    ngOnDestroy() {
        clearInterval(this.interval)
    }

    click() {
        if (!this.orderService.appuser) {
            this.navCtrl.navigateRoot('login');
        }
    }

    refresh() {
        let me = this;
        me.ready = false;
        setTimeout(function () {
            me.ready = true;
        });

        // let me = this;
        // let filters = {
        //     'userMeet': true,
        //     'mainAppuser': true,
        //     'resJson': true,
        // };
        // this.modelProvider.custom('templateg', filters).then(function (data: any) {
        //     console.log(data);
        //     me.pageData = data['data'];
        // });
    }

}
